export const inputSelected = [() => {
  return {
      restrict: 'A',
      link: function(scope, el) {
          scope.isSelected = el.find('input').val() == 'false';
          scope.bgCol = '#ccc';
          el.on('click', function() {
              scope.isSelected = !scope.isSelected;
              if (scope.isSelected) scope.dbmcolor = 'grey';
              else scope.dbmcolor = 'transparent';
              scope.$apply();
          });
      }
  };
}];



// WEBPACK FOOTER //
// ./src/app/common/directives/inputSelected.js